import { getInstance } from '@module-federation/enhanced/runtime';
import { generateSnapshotFromManifest, getResourceUrl } from '@module-federation/sdk';
import { getManifestUrl } from './utils';
import enviro from 'enviro';
function getInstanceSafe() {
  const instance = getInstance();
  if (!instance) {
    throw new Error('Module federation instance not found');
  }
  return instance;
}
export function registerRemoteModules(remoteNames) {
  const remotes = remoteNames.map(remoteName => ({
    name: remoteName,
    entry: getManifestUrl(remoteName)
  }));
  getInstanceSafe().registerRemotes(remotes);
}
export function loadRemoteModule(appName, path = '') {
  return getInstanceSafe().loadRemote(`${appName}${path ? `/${path}` : ''}`);
}
export function loadRemoteDlbs(appName) {
  return loadRemoteModule(appName, 'load-dlbs').then(mod => mod.loadRemoteDlbs());
}
export function fetchGraniteRemote(appName) {
  return loadRemoteModule(appName);
}
export function loadGraniteRemote(appName) {
  return fetchGraniteRemote(appName).then(mod => mod.loadEntry());
}
export function preloadRemoteModule(moduleName, exposes = ['.']) {
  getInstanceSafe().preloadRemote([{
    nameOrAlias: moduleName,
    // Fetch all sync files, if we were to use the "all" option here,
    // unused modules would be fetched, even language files for non-active locales
    resourceCategory: 'sync',
    exposes
  }]).catch(error => {
    if (!enviro.deployed()) {
      console.error(error);
    }
  });
}
export function preloadGraniteRemote(moduleName) {
  preloadRemoteModule(moduleName, ['.', 'lang']);
}
function getVarSafeName(name) {
  return name.replace(/-/g, '_');
}
function getManifestForRemote(remoteName) {
  const instance = getInstance();
  if (!instance) {
    return undefined;
  }
  const varSafeName = getVarSafeName(remoteName);
  for (const [, manifest] of instance.snapshotHandler.manifestCache) {
    if (manifest.id === varSafeName || manifest.id === remoteName) {
      return manifest;
    }
  }
  return undefined;
}
export function getRemoteCssUrl(remoteName) {
  const manifest = getManifestForRemote(remoteName);
  if (!manifest) {
    return undefined;
  }
  const snapshot = generateSnapshotFromManifest(manifest);
  return getResourceUrl(snapshot, 'css/app.css');
}